import { Component, OnInit } from '@angular/core';
import { URL_ROOT_PATH, URL_AUTH_GOOGLE, CLIENT_ID} from 'src/assets/js/global';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  urlGoogleLogin = URL_AUTH_GOOGLE + '&redirect_uri=' + URL_ROOT_PATH + '/login-google&response_type=code'+ CLIENT_ID;
  urlSignup = URL_ROOT_PATH + '/system/user/register';
  constructor() { }

  ngOnInit(): void {
  }
  onClickSignUp(){
    alert(1);
  }
  goToLink(){
    console.log(this.urlGoogleLogin);
    $(location).attr('href', this.urlGoogleLogin);
    //return 1;
  }
}
